import { Component } from '@angular/core';
import { WidgetBaseComponent } from '@shared/widgets/widget-base/widget-base.component';

@Component({
  selector: 'app-header-club',
  templateUrl: './header-club.component.html',
  styleUrls: ['./header-club.component.scss'],
})
export class HeaderClubComponent extends WidgetBaseComponent {
  constructor() {
    super();
  }
}
